function isMobile() {
  return window.innerWidth < 768;
}

function scrollTo($obj, offset = 100) {
  $('html,body').animate({
    scrollTop: $obj.offset().top - offset
  }, 1000);
}

function priceFormat(val) {
  return val.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

function numberFormat(val, digits = 2) {
  return val.toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  });
}

function filterDigits(txt) {
  return Number((String(txt)).replace(/\D+/g, ''));
}

if (typeof readyCallbacks !== 'undefined') {
  readyCallbacks.setReady();
}

jQuery.event.special.touchstart = {
  setup: function( _, ns, handle ){
    this.addEventListener("touchstart", handle, { passive: true });
  }
};